import { render } from "./ConfirmOrder.vue?vue&type=template&id=7c40abc8&scoped=true"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js"

import "./ConfirmOrder.vue?vue&type=style&index=0&id=7c40abc8&lang=scss&scoped=true"
import "./ConfirmOrder.vue?vue&type=style&index=1&id=7c40abc8&lang=css"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c40abc8"]])

export default __exports__